module.exports = __webpack_public_path__ + "static/media/tkd_1.abf1c914.jpg";